/**
 * Product Section Navigation — Artemis Therapeutics
 *
 * Always-visible sticky tab bar with scroll-spy. Desktop + mobile.
 * Handles: active-tab highlighting, smooth-scroll on click, and
 * escaping Craft theme's scroll-trigger transform context.
 *
 * Header tracking: The nav dynamically follows the Craft
 * sticky header — sitting below it when visible, sliding
 * to viewport top when the header hides on scroll-down.
 *
 * Revert: Delete this file + product-section-nav.liquid snippet +
 *         CSS section CRO-2c from artemis-custom.css
 */
(function () {
  var nav = document.getElementById('product-section-nav');
  if (!nav) return;

  /* ── Escape scroll-trigger transform context ── */
  document.body.appendChild(nav);

  /* ── Derive section ID prefix from Liquid context ── */
  var sectionId = nav.getAttribute('data-section-id') || '';
  var prefix = '';
  var underscorePos = sectionId.lastIndexOf('__');
  if (underscorePos !== -1) {
    prefix = sectionId.substring(0, underscorePos + 2);
  }

  /* ── Collect section targets ── */
  var tabs = nav.querySelectorAll('.product-section-nav__tab');
  var sections = [];

  tabs.forEach(function (tab) {
    var targetId = 'shopify-section-' + prefix + tab.getAttribute('data-target');
    var el = document.getElementById(targetId);
    if (el) {
      sections.push({ id: targetId, el: el, tab: tab });
    }
  });

  if (sections.length === 0) return;

  /* ── Header tracking ── */
  var headerSection = document.querySelector('.section-header');
  /* Measure actual nav height — responsive (36px mobile, 48px desktop) */
  var navHeight = nav.offsetHeight || 48;

  function getHeaderBottom() {
    if (!headerSection) return 0;
    var bottom = headerSection.getBoundingClientRect().bottom;
    return bottom > 0 ? bottom : 0;
  }

  function updateNavPosition() {
    var headerBottom = getHeaderBottom();
    nav.style.transform = 'translateY(' + headerBottom + 'px)';
  }

  /* ── Show nav immediately (always visible on desktop) ── */
  nav.classList.add('product-section-nav--visible');
  updateNavPosition();

  /* ── Offset product content to clear the fixed nav ── */
  var mainSection = document.getElementById('shopify-section-' + prefix + 'main');
  if (mainSection) {
    mainSection.style.paddingTop = (navHeight + 16) + 'px';
  }

  /* ── Scroll spy — highlight active section tab ── */
  var activeTab = tabs[0];

  function updateSpy() {
    var headerBottom = getHeaderBottom();
    var offset = headerBottom + navHeight + 20;
    var current = null;

    for (var i = sections.length - 1; i >= 0; i--) {
      if (sections[i].el.getBoundingClientRect().top <= offset) {
        current = sections[i];
        break;
      }
    }

    if (current && current.tab !== activeTab) {
      if (activeTab) activeTab.classList.remove('product-section-nav__tab--active');
      current.tab.classList.add('product-section-nav__tab--active');
      activeTab = current.tab;

      /* Auto-scroll active tab into view */
      current.tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }

  /* ── Scroll handler ── */
  var spyTicking = false;
  window.addEventListener('scroll', function () {
    /* Position update is synchronous — no rAF delay, stays locked to header */
    updateNavPosition();

    /* Spy update is less critical — throttle via rAF */
    if (!spyTicking) {
      requestAnimationFrame(function () {
        updateSpy();
        spyTicking = false;
      });
      spyTicking = true;
    }
  }, { passive: true });

  /* ── Click handler — smooth scroll to section ── */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = 'shopify-section-' + prefix + tab.getAttribute('data-target');
      var el = document.getElementById(targetId);
      if (!el) return;

      var headerBottom = getHeaderBottom();
      var offset = headerBottom + navHeight + 8;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  /* ── Initial spy check ── */
  updateSpy();
})();
